export const currenciesList = [
  { value: 'uah', label: 'Ukrainian Hryvnia (UAH)' },
  { value: 'usd', label: 'US Dollar (USD)' },
  { value: 'eur', label: 'Euro (EUR)' },
  { value: 'btc', label: 'Bitcoin (BTC)' },
  { value: 'usdt', label: 'Tether (USDT)' },
  { value: '00', label: '00 Token (00)' },
  { value: '1inch', label: '1inch (1INCH)' },
  { value: 'aave', label: 'Aave (AAVE)' },
  { value: 'abt', label: 'Arcblock (ABT)' },
  { value: 'ach', label: 'Alchemy Pay (ACH)' },
  { value: 'acs', label: 'ACryptoS (ACS)' },
  { value: 'ada', label: 'Cardano (ADA)' },
  { value: 'aed', label: 'Emirati Dirham (AED)' },
  { value: 'aergo', label: 'Aergo (AERGO)' },
  { value: 'afn', label: 'Afghan Afghani (AFN)' },
  { value: 'agld', label: 'Adventure Gold (AGLD)' },
  { value: 'aioz', label: 'Aioz Network (AIOZ)' },
  { value: 'akt', label: 'Akash Network (AKT)' },
  { value: 'alcx', label: 'Alchemix (ALCX)' },
  { value: 'aleph', label: 'Aleph.im (ALEPH)' },
  { value: 'algo', label: 'Algorand (ALGO)' },
  { value: 'alice', label: 'My Neighbor Alice (ALICE)' },
  { value: 'all', label: 'Albanian Lek (ALL)' },
  { value: 'amd', label: 'Armenian Dram (AMD)' },
  { value: 'amp', label: 'Amp (AMP)' },
  { value: 'ang', label: 'Dutch Guilder (ANG)' },
  { value: 'ankr', label: 'Ankr Network (ANKR)' },
  { value: 'ant', label: 'Aragon (ANT)' },
  { value: 'aoa', label: 'Angolan Kwanza (AOA)' },
  { value: 'ape', label: 'ApeCoin (APE)' },
  { value: 'api3', label: 'API3 (API3)' },
  { value: 'apt', label: 'Aptos (APT)' },
  { value: 'ar', label: 'Arweave (AR)' },
  { value: 'arb', label: 'Arbitrum (ARB)' },
  { value: 'arpa', label: 'ARPA Chain (ARPA)' },
  { value: 'ars', label: 'Argentine Peso (ARS)' },
  { value: 'asm', label: 'Assemble Protocol (ASM)' },
  { value: 'ast', label: 'AirSwap (AST)' },
  { value: 'ata', label: 'Automata Network (ATA)' },
  { value: 'atom', label: 'Cosmos (ATOM)' },
  { value: 'ats', label: 'Austrian Schilling (ATS)' },
  { value: 'auction', label: 'Bounce Token AUCTION (AUCTION)' },
  { value: 'aud', label: 'Australian Dollar (AUD)' },
  { value: 'audio', label: 'Audius (AUDIO)' },
  { value: 'aurora', label: 'Aurora (AURORA)' },
  { value: 'avax', label: 'Avalanche (AVAX)' },
  { value: 'avt', label: 'Aventus (AVT)' },
  { value: 'awg', label: 'Aruban or Dutch Guilder (AWG)' },
  { value: 'axl', label: 'Axelar (AXL)' },
  { value: 'axs', label: 'Axie Infinity (AXS)' },
  { value: 'azm', label: 'Azerbaijani Manat (AZM)' },
  { value: 'azn', label: 'Azerbaijan Manat (AZN)' },
  { value: 'badger', label: 'Badger DAO (BADGER)' },
  { value: 'bake', label: 'BakeryToken (BAKE)' },
  { value: 'bal', label: 'Balancer (BAL)' },
  { value: 'bam', label: 'Bosnian Convertible Mark (BAM)' },
  { value: 'band', label: 'Band Protocol (BAND)' },
  { value: 'bat', label: 'Basic Attention Token (BAT)' },
  { value: 'bbd', label: 'Barbadian or Bajan Dollar (BBD)' },
  { value: 'bch', label: 'Bitcoin Cash (BCH)' },
  { value: 'bdt', label: 'Bangladeshi Taka (BDT)' },
  { value: 'bef', label: 'Belgian Franc (BEF)' },
  { value: 'bgn', label: 'Bulgarian Lev (BGN)' },
  { value: 'bhd', label: 'Bahraini Dinar (BHD)' },
  { value: 'bico', label: 'Biconomy (BICO)' },
  { value: 'bif', label: 'Burundian Franc (BIF)' },
  { value: 'bigtime', label: ' (BIGTIME)' },
  { value: 'bit', label: 'BitDAO (BIT)' },
  { value: 'blur', label: 'Blur (BLUR)' },
  { value: 'blz', label: 'Bluzelle (BLZ)' },
  { value: 'bmd', label: 'Bermudian Dollar (BMD)' },
  { value: 'bnb', label: 'Binance Coin (BNB)' },
  { value: 'bnd', label: 'Bruneian Dollar (BND)' },
  { value: 'bnt', label: 'Bancor Network (BNT)' },
  { value: 'bob', label: 'Bolivian Bolíviano (BOB)' },
  { value: 'boba', label: 'Boba Network (BOBA)' },
  { value: 'bond', label: 'BarnBridge (BOND)' },
  { value: 'brl', label: 'Brazilian Real (BRL)' },
  { value: 'bsd', label: 'Bahamian Dollar (BSD)' },
  { value: 'bsv', label: 'Bitcoin SV (BSV)' },
  { value: 'bsw', label: 'Biswap (BSW)' },
  { value: 'btcb', label: 'Bitcoin BEP2 (BTCB)' },
  { value: 'btg', label: 'Bitcoin Gold (BTG)' },
  { value: 'btn', label: 'Bhutanese Ngultrum (BTN)' },
  { value: 'btrst', label: 'Braintrust (BTRST)' },
  { value: 'btt', label: 'BitTorrent (BTT)' },
  { value: 'busd', label: 'Binance USD (BUSD)' },
  { value: 'bwp', label: 'Botswana Pula (BWP)' },
  { value: 'byn', label: 'Belarusian Ruble (BYN)' },
  { value: 'byr', label: 'Belarusian Ruble (BYR)' },
  { value: 'bzd', label: 'Belizean Dollar (BZD)' },
  { value: 'c98', label: 'Coin98 (C98)' },
  { value: 'cad', label: 'Canadian Dollar (CAD)' },
  { value: 'cake', label: 'PancakeSwap (CAKE)' },
  { value: 'cbeth', label: 'Coinbase Wrapped Staked ETH (CBETH)' },
  { value: 'cdf', label: 'Congolese Franc (CDF)' },
  { value: 'celo', label: 'Celo (CELO)' },
  { value: 'celr', label: 'Celer Network (CELR)' },
  { value: 'cfx', label: 'Conflux (CFX)' },
  { value: 'cgld', label: 'Celo Gold (CGLD)' },
  { value: 'chf', label: 'Swiss Franc (CHF)' },
  { value: 'chz', label: 'Chiliz (CHZ)' },
  { value: 'clp', label: 'Chilean Peso (CLP)' },
  { value: 'clv', label: 'Clover Finance (CLV)' },
  { value: 'cnh', label: 'Chinese Yuan Renminbi Offshore (CNH)' },
  { value: 'cny', label: 'Chinese Yuan Renminbi (CNY)' },
  { value: 'comp', label: 'Compound (COMP)' },
  { value: 'cop', label: 'Colombian Peso (COP)' },
  { value: 'coti', label: 'COTI (COTI)' },
  { value: 'coval', label: 'COVAL (COVAL)' },
  { value: 'crc', label: 'Costa Rican Colon (CRC)' },
  { value: 'cro', label: 'Crypto.com Chain (CRO)' },
  { value: 'crpt', label: 'Crypterium (CRPT)' },
  { value: 'crv', label: 'Curve DAO Token (CRV)' },
  { value: 'cspr', label: 'Casper (CSPR)' },
  { value: 'ctsi', label: 'Cartesi (CTSI)' },
  { value: 'ctx', label: 'Cryptex Finance (CTX)' },
  { value: 'cuc', label: 'Cuban Convertible Peso (CUC)' },
  { value: 'cup', label: 'Cuban Peso (CUP)' },
  { value: 'cvc', label: 'Civic (CVC)' },
  { value: 'cve', label: 'Cape Verdean Escudo (CVE)' },
  { value: 'cvx', label: 'Convex Finance (CVX)' },
  { value: 'cyp', label: 'Cypriot Pound (CYP)' },
  { value: 'czk', label: 'Czech Koruna (CZK)' },
  { value: 'dai', label: 'DAI (DAI)' },
  { value: 'dar', label: 'Mines of Dalarnia (DAR)' },
  { value: 'dash', label: 'Digital Cash (DASH)' },
  { value: 'dcr', label: 'Decred (DCR)' },
  { value: 'ddx', label: 'DerivaDAO (DDX)' },
  { value: 'dem', label: 'German Deutsche Mark (DEM)' },
  { value: 'deso', label: 'Decentralized Social (DESO)' },
  { value: 'dext', label: 'DEXTools (DEXT)' },
  { value: 'dfi', label: 'DfiStarter (DFI)' },
  { value: 'dia', label: 'Dia (DIA)' },
  { value: 'dimo', label: 'DIMO (DIMO)' },
  { value: 'djf', label: 'Djiboutian Franc (DJF)' },
  { value: 'dkk', label: 'Danish Krone (DKK)' },
  { value: 'dnt', label: 'District0x (DNT)' },
  { value: 'doge', label: 'Dogecoin (DOGE)' },
  { value: 'dop', label: 'Dominican Peso (DOP)' },
  { value: 'dot', label: 'Polkadot (DOT)' },
  { value: 'drep', label: 'Drep [new] (DREP)' },
  { value: 'dyp', label: 'DeFi Yield Protocol (DYP)' },
  { value: 'dzd', label: 'Algerian Dinar (DZD)' },
  { value: 'eek', label: 'Estonian Kroon (EEK)' },
  { value: 'egld', label: 'Elrond (EGLD)' },
  { value: 'egp', label: 'Egyptian Pound (EGP)' },
  { value: 'ela', label: 'Elastos (ELA)' },
  { value: 'enj', label: 'Enjin Coin (ENJ)' },
  { value: 'ens', label: 'Ethereum Name Service (ENS)' },
  { value: 'eos', label: 'EOS (EOS)' },
  { value: 'ern', label: 'Eritrean Nakfa (ERN)' },
  { value: 'esp', label: 'Spanish Peseta (ESP)' },
  { value: 'etb', label: 'Ethiopian Birr (ETB)' },
  { value: 'etc', label: 'Ethereum Classic (ETC)' },
  { value: 'eth', label: 'Ethereum (ETH)' },
  { value: 'eth2', label: 'Ethereum 2.0 (ETH2)' },
  { value: 'euroc', label: 'Euro Coin (EUROC)' },
  { value: 'farm', label: 'Harvest Finance (FARM)' },
  { value: 'fei', label: 'Fei USD (FEI)' },
  { value: 'fet', label: 'Fetch.ai (FET)' },
  { value: 'fida', label: 'Bonfida (FIDA)' },
  { value: 'fil', label: 'Filecoin (FIL)' },
  { value: 'fim', label: 'Finnish Markka (FIM)' },
  { value: 'fis', label: 'Stafi (FIS)' },
  { value: 'fjd', label: 'Fijian Dollar (FJD)' },
  { value: 'fkp', label: 'Falkland Island Pound (FKP)' },
  { value: 'flow', label: 'Flow (FLOW)' },
  { value: 'flr', label: 'FLARE (FLR)' },
  { value: 'fort', label: 'Forta (FORT)' },
  { value: 'forth', label: 'Ampleforth Governance Token (FORTH)' },
  { value: 'fox', label: 'Shapeshift FOX Token (FOX)' },
  { value: 'frax', label: 'Frax (FRAX)' },
  { value: 'frf', label: 'French Franc (FRF)' },
  { value: 'ftm', label: 'Fantom (FTM)' },
  { value: 'ftt', label: 'FarmaTrust (FTT)' },
  { value: 'fx', label: 'Function X (FX)' },
  { value: 'fxs', label: 'Frax Share (FXS)' },
  { value: 'gal', label: 'Project Galaxy (GAL)' },
  { value: 'gala', label: 'Gala (GALA)' },
  { value: 'gbp', label: 'British Pound (GBP)' },
  { value: 'gel', label: 'Georgian Lari (GEL)' },
  { value: 'gfi', label: 'Goldfinch (GFI)' },
  { value: 'ggp', label: 'Guernsey Pound (GGP)' },
  { value: 'ghc', label: 'Ghanaian Cedi (GHC)' },
  { value: 'ghs', label: 'Ghanaian Cedi (GHS)' },
  { value: 'ghst', label: 'Aavegotchi (GHST)' },
  { value: 'gip', label: 'Gibraltar Pound (GIP)' },
  { value: 'glm', label: 'Golem (GLM)' },
  { value: 'gmd', label: 'Gambian Dalasi (GMD)' },
  { value: 'gmt', label: 'Stepn (GMT)' },
  { value: 'gmx', label: 'Goldmaxcoin (GMX)' },
  { value: 'gnf', label: 'Guinean Franc (GNF)' },
  { value: 'gno', label: 'Gnosis (GNO)' },
  { value: 'gnt', label: 'GreenTrust (GNT)' },
  { value: 'gods', label: 'Gods Unchained (GODS)' },
  { value: 'grd', label: 'Greek Drachma (GRD)' },
  { value: 'grt', label: 'The Graph (GRT)' },
  { value: 'gst', label: 'Green Satoshi Token (GST)' },
  { value: 'gt', label: 'GateToken (GT)' },
  { value: 'gtc', label: 'Gitcoin (GTC)' },
  { value: 'gtq', label: 'Guatemalan Quetzal (GTQ)' },
  { value: 'gusd', label: 'Gemini US Dollar (GUSD)' },
  { value: 'gyd', label: 'Guyanese Dollar (GYD)' },
  { value: 'gyen', label: 'GYEN (GYEN)' },
  { value: 'hbar', label: 'Hedera (HBAR)' },
  { value: 'hft', label: 'Hashflow (HFT)' },
  { value: 'high', label: 'Highstreet (HIGH)' },
  { value: 'hkd', label: 'Hong Kong Dollar (HKD)' },
  { value: 'hnl', label: 'Honduran Lempira (HNL)' },
  { value: 'hnt', label: 'Helium (HNT)' },
  { value: 'hopr', label: 'HOPR (HOPR)' },
  { value: 'hot', label: 'Hydro Protocol (HOT)' },
  { value: 'hrk', label: 'Croatian Kuna (HRK)' },
  { value: 'ht', label: 'Huobi Token (HT)' },
  { value: 'htg', label: 'Haitian Gourde (HTG)' },
  { value: 'huf', label: 'Hungarian Forint (HUF)' },
  { value: 'icp', label: 'Internet Computer (ICP)' },
  { value: 'idex', label: 'IDEX (IDEX)' },
  { value: 'idr', label: 'Indonesian Rupiah (IDR)' },
  { value: 'iep', label: 'Irish Pound (IEP)' },
  { value: 'ils', label: 'Israeli Shekel (ILS)' },
  { value: 'ilv', label: 'Illuvium (ILV)' },
  { value: 'imp', label: 'Isle of Man Pound (IMP)' },
  { value: 'imx', label: 'Immutable X (IMX)' },
  { value: 'index', label: 'Index Cooperative (INDEX)' },
  { value: 'inj', label: 'Injective (INJ)' },
  { value: 'inr', label: 'Indian Rupee (INR)' },
  { value: 'inv', label: 'Inverse Finance (INV)' },
  { value: 'iotx', label: 'IoTeX (IOTX)' },
  { value: 'iqd', label: 'Iraqi Dinar (IQD)' },
  { value: 'irr', label: 'Iranian Rial (IRR)' },
  { value: 'isk', label: 'Icelandic Krona (ISK)' },
  { value: 'itl', label: 'Italian Lira (ITL)' },
  { value: 'jasmy', label: 'Jasmy (JASMY)' },
  { value: 'jep', label: 'Jersey Pound (JEP)' },
  { value: 'jmd', label: 'Jamaican Dollar (JMD)' },
  { value: 'jod', label: 'Jordanian Dinar (JOD)' },
  { value: 'jpy', label: 'Japanese Yen (JPY)' },
  { value: 'jup', label: 'Jupiter (JUP)' },
  { value: 'kas', label: ' (KAS)' },
  { value: 'kava', label: 'Kava (KAVA)' },
  { value: 'kcs', label: 'Kucoin (KCS)' },
  { value: 'kda', label: 'Kadena (KDA)' },
  { value: 'keep', label: 'Keep Network (KEEP)' },
  { value: 'kes', label: 'Kenyan Shilling (KES)' },
  { value: 'kgs', label: 'Kyrgyzstani Som (KGS)' },
  { value: 'khr', label: 'Cambodian Riel (KHR)' },
  { value: 'klay', label: 'Klaytn (KLAY)' },
  { value: 'kmf', label: 'Comorian Franc (KMF)' },
  { value: 'knc', label: 'Kyber Network Crystals (KNC)' },
  { value: 'kpw', label: 'North Korean Won (KPW)' },
  { value: 'krl', label: 'Kryll (KRL)' },
  { value: 'krw', label: 'South Korean Won (KRW)' },
  { value: 'ksm', label: 'Kusama (KSM)' },
  { value: 'kwd', label: 'Kuwaiti Dinar (KWD)' },
  { value: 'kyd', label: 'Caymanian Dollar (KYD)' },
  { value: 'kzt', label: 'Kazakhstani Tenge (KZT)' },
  { value: 'lak', label: 'Lao Kip (LAK)' },
  { value: 'lbp', label: 'Lebanese Pound (LBP)' },
  { value: 'lcx', label: 'LCX (LCX)' },
  { value: 'ldo', label: 'Lido DAO Token (LDO)' },
  { value: 'leo', label: 'LEOcoin (LEO)' },
  { value: 'link', label: 'Chainlink (LINK)' },
  { value: 'lit', label: 'Litentry (LIT)' },
  { value: 'lkr', label: 'Sri Lankan Rupee (LKR)' },
  { value: 'loka', label: 'League of Kingdoms Arena (LOKA)' },
  { value: 'loom', label: 'Loom Network (LOOM)' },
  { value: 'lpt', label: 'Livepeer (LPT) (LPT)' },
  { value: 'lqty', label: 'Liquity (LQTY)' },
  { value: 'lrc', label: 'Loopring (LRC)' },
  { value: 'lrd', label: 'Liberian Dollar (LRD)' },
  { value: 'lseth', label: 'Liquid Staked Ethereum (LSETH)' },
  { value: 'lsl', label: 'Basotho Loti (LSL)' },
  { value: 'ltc', label: 'Litecoin (LTC)' },
  { value: 'ltl', label: 'Lithuanian Litas (LTL)' },
  { value: 'luf', label: 'Luxembourg Franc (LUF)' },
  { value: 'luna', label: 'Terra (LUNA)' },
  { value: 'lunc', label: ' (LUNC)' },
  { value: 'lvl', label: 'Latvian Lat (LVL)' },
  { value: 'lyd', label: 'Libyan Dinar (LYD)' },
  { value: 'mad', label: 'Moroccan Dirham (MAD)' },
  { value: 'magic', label: 'MAGIC (MAGIC)' },
  { value: 'mana', label: 'Mana Coin Decentraland (MANA)' },
  { value: 'mask', label: 'Mask Network (MASK)' },
  { value: 'math', label: 'MATH (MATH)' },
  { value: 'matic', label: 'Polygon (MATIC)' },
  { value: 'mco2', label: 'Moss Carbon Credit (MCO2)' },
  { value: 'mdl', label: 'Moldovan Leu (MDL)' },
  { value: 'mdt', label: 'Measurable Data Token (MDT)' },
  { value: 'media', label: 'Media Network (MEDIA)' },
  { value: 'metis', label: 'MetisDAO (METIS)' },
  { value: 'mga', label: 'Malagasy Ariary (MGA)' },
  { value: 'mgf', label: 'Malagasy Franc (MGF)' },
  { value: 'mina', label: 'Mina (MINA)' },
  { value: 'mir', label: 'Mirror Protocol (MIR)' },
  { value: 'mkd', label: 'Macedonian Denar (MKD)' },
  { value: 'mkr', label: 'Maker (MKR)' },
  { value: 'mln', label: 'Enzyme (MLN)' },
  { value: 'mmk', label: 'Burmese Kyat (MMK)' },
  { value: 'mnde', label: 'Marinade (MNDE)' },
  { value: 'mnt', label: 'Mongolian Tughrik (MNT)' },
  { value: 'mona', label: 'Monavale (MONA)' },
  { value: 'mop', label: 'Macau Pataca (MOP)' },
  { value: 'mpl', label: 'Maple (MPL)' },
  { value: 'mro', label: 'Mauritanian Ouguiya (MRO)' },
  { value: 'mru', label: 'Mauritanian Ouguiya (MRU)' },
  { value: 'msol', label: 'Marinade Staked SOL (MSOL)' },
  { value: 'mtl', label: 'Maltese Lira (MTL)' },
  { value: 'multi', label: 'Multichain (MULTI)' },
  { value: 'mur', label: 'Mauritian Rupee (MUR)' },
  { value: 'musd', label: 'mStableUSD (MUSD)' },
  { value: 'muse', label: 'Muse (MUSE)' },
  { value: 'mvr', label: 'Maldivian Rufiyaa (MVR)' },
  { value: 'mwk', label: 'Malawian Kwacha (MWK)' },
  { value: 'mxc', label: 'MXC (MXC)' },
  { value: 'mxn', label: 'Mexican Peso (MXN)' },
  { value: 'mxv', label: ' (MXV)' },
  { value: 'myr', label: 'Malaysian Ringgit (MYR)' },
  { value: 'mzm', label: 'Mozambican Metical (MZM)' },
  { value: 'mzn', label: 'Mozambican Metical (MZN)' },
  { value: 'nad', label: 'Namibian Dollar (NAD)' },
  { value: 'nct', label: 'Polyswarm (NCT)' },
  { value: 'near', label: 'NEAR Protocol (NEAR)' },
  { value: 'neo', label: 'NEO (NEO)' },
  { value: 'nest', label: 'NEST Protocol (NEST)' },
  { value: 'nexo', label: 'NEXO (NEXO)' },
  { value: 'nft', label: 'NFT (NFT)' },
  { value: 'ngn', label: 'Nigerian Naira (NGN)' },
  { value: 'nio', label: 'Nicaraguan Cordoba (NIO)' },
  { value: 'nkn', label: 'NKN (NKN)' },
  { value: 'nlg', label: 'Dutch Guilder (NLG)' },
  { value: 'nmr', label: 'Numeraire Network (NMR)' },
  { value: 'nok', label: 'Norwegian Krone (NOK)' },
  { value: 'npr', label: 'Nepalese Rupee (NPR)' },
  { value: 'nu', label: 'NuCypher (NU)' },
  { value: 'nzd', label: 'New Zealand Dollar (NZD)' },
  { value: 'ocean', label: 'Ocean Protocol (OCEAN)' },
  { value: 'ogn', label: 'Origin Token (OGN)' },
  { value: 'okb', label: 'Okex (OKB)' },
  { value: 'omg', label: 'Omisego (OMG)' },
  { value: 'omr', label: 'Omani Rial (OMR)' },
  { value: 'one', label: 'Menlo One (ONE)' },
  { value: 'ooki', label: 'Ooki Protocol (OOKI)' },
  { value: 'op', label: 'Optimism (OP)' },
  { value: 'orca', label: 'Orca (ORCA)' },
  { value: 'orn', label: 'Orion Protocol (ORN)' },
  { value: 'osmo', label: 'Osmosis (OSMO)' },
  { value: 'oxt', label: 'Orchid Network (OXT)' },
  { value: 'pab', label: 'Panamanian Balboa (PAB)' },
  { value: 'pax', label: 'Paxos Standard Token (PAX)' },
  { value: 'paxg', label: 'PAX Gold (PAXG)' },
  { value: 'pen', label: 'Peruvian Sol (PEN)' },
  { value: 'pepe', label: ' (PEPE)' },
  { value: 'perp', label: 'Perpetual Protocol (PERP)' },
  { value: 'pgk', label: 'Papua New Guinean Kina (PGK)' },
  { value: 'php', label: 'Philippine Peso (PHP)' },
  { value: 'pkr', label: 'Pakistani Rupee (PKR)' },
  { value: 'pla', label: 'PlayDapp (PLA)' },
  { value: 'pln', label: 'Polish Zloty (PLN)' },
  { value: 'plu', label: 'Pluton (PLU)' },
  { value: 'png', label: 'Pangolin (PNG)' },
  { value: 'pols', label: 'Polkastarter (POLS)' },
  { value: 'poly', label: 'Polymath (POLY)' },
  { value: 'pond', label: 'Marlin (POND)' },
  { value: 'powr', label: 'Powerledger (POWR)' },
  { value: 'prime', label: 'Echelon Prime (PRIME)' },
  { value: 'pro', label: 'Propy (PRO)' },
  { value: 'prq', label: 'PARSIQ (PRQ)' },
  { value: 'pte', label: 'Portuguese Escudo (PTE)' },
  { value: 'pundix', label: 'Pundi X (NEW) (PUNDIX)' },
  { value: 'pyg', label: 'Paraguayan Guarani (PYG)' },
  { value: 'pyr', label: 'Vulcan Forged PYR (PYR)' },
  { value: 'pyusd', label: ' (PYUSD)' },
  { value: 'qar', label: 'Qatari Riyal (QAR)' },
  { value: 'qi', label: 'BENQI (QI)' },
  { value: 'qnt', label: 'Quant (QNT)' },
  { value: 'qsp', label: 'Quantstamp (QSP)' },
  { value: 'qtum', label: 'QTUM (QTUM)' },
  { value: 'quick', label: 'QuickSwap (QUICK)' },
  { value: 'rad', label: 'Radicle (RAD)' },
  { value: 'rai', label: 'Rai Reflex Index (RAI)' },
  { value: 'rare', label: 'SuperRare (RARE)' },
  { value: 'rari', label: 'Rarible (RARI)' },
  { value: 'rbn', label: 'Ribbon FInance (RBN)' },
  { value: 'ren', label: 'renBTC (REN)' },
  { value: 'rep', label: 'Augur (REP)' },
  { value: 'repv2', label: 'REPv2 (REPV2)' },
  { value: 'req', label: 'Request (REQ)' },
  { value: 'rgt', label: 'Rari Governance Token (RGT)' },
  { value: 'rlc', label: 'iExec RLC (RLC)' },
  { value: 'rly', label: 'Rally (RLY)' },
  { value: 'rndr', label: 'Render Token (RNDR)' },
  { value: 'rol', label: 'Romanian Leu (ROL)' },
  { value: 'ron', label: 'Romanian Leu (RON)' },
  { value: 'rose', label: 'Oasis Network (ROSE)' },
  { value: 'rpl', label: 'Rocket Pool (RPL)' },
  { value: 'rsd', label: 'Serbian Dinar (RSD)' },
  { value: 'rub', label: 'Russian Ruble (RUB)' },
  { value: 'rune', label: 'THORChain (ERC20) (RUNE)' },
  { value: 'rvn', label: 'Ravencoin (RVN)' },
  { value: 'rwf', label: 'Rwandan Franc (RWF)' },
  { value: 'sand', label: 'The Sandbox (SAND)' },
  { value: 'sar', label: 'Saudi Arabian Riyal (SAR)' },
  { value: 'sbd', label: 'Solomon Islander Dollar (SBD)' },
  { value: 'scr', label: 'Seychellois Rupee (SCR)' },
  { value: 'sdd', label: 'Sudanese Dinar (SDD)' },
  { value: 'sdg', label: 'Sudanese Pound (SDG)' },
  { value: 'sei', label: ' (SEI)' },
  { value: 'sek', label: 'Swedish Krona (SEK)' },
  { value: 'sgd', label: 'Singapore Dollar (SGD)' },
  { value: 'shib', label: 'Shiba Inu (SHIB)' },
  { value: 'shp', label: 'Saint Helenian Pound (SHP)' },
  { value: 'shping', label: 'Shping Coin (SHPING)' },
  { value: 'sit', label: 'Slovenian Tolar (SIT)' },
  { value: 'skk', label: 'Slovak Koruna (SKK)' },
  { value: 'skl', label: 'SKALE Network (SKL)' },
  { value: 'sle', label: 'Sierra Leonean Leone (SLE)' },
  { value: 'sll', label: 'Sierra Leonean Leone (SLL)' },
  { value: 'snt', label: 'Status Network (SNT)' },
  { value: 'snx', label: 'Synthetix Network (SNX)' },
  { value: 'sol', label: 'Solana (SOL)' },
  { value: 'sos', label: 'Somali Shilling (SOS)' },
  { value: 'spa', label: 'Sperax (SPA)' },
  { value: 'spell', label: 'Spell Token (SPELL)' },
  { value: 'spl', label: 'Seborgan Luigino (SPL)' },
  { value: 'srd', label: 'Surinamese Dollar (SRD)' },
  { value: 'srg', label: 'Surinamese Guilder (SRG)' },
  { value: 'ssp', label: 'South Sudanese Pound (SSP)' },
  { value: 'std', label: 'Sao Tomean Dobra (STD)' },
  { value: 'stg', label: 'Stargate Finance (STG)' },
  { value: 'stn', label: 'Sao Tomean Dobra (STN)' },
  { value: 'storj', label: 'Storj (STORJ)' },
  { value: 'stx', label: 'Stacks (STX)' },
  { value: 'sui', label: 'Sui (SUI)' },
  { value: 'suku', label: 'SUKU (SUKU)' },
  { value: 'super', label: 'SuperFarm (SUPER)' },
  { value: 'sushi', label: 'SushiSwap (SUSHI)' },
  { value: 'svc', label: 'Salvadoran Colon (SVC)' },
  { value: 'swftc', label: 'SwftCoin (SWFTC)' },
  { value: 'sylo', label: 'Sylo (SYLO)' },
  { value: 'syn', label: 'Synapse (SYN)' },
  { value: 'syp', label: 'Syrian Pound (SYP)' },
  { value: 'szl', label: 'Swazi Lilangeni (SZL)' },
  { value: 't', label: 'Threshold (T)' },
  { value: 'thb', label: 'Thai Baht (THB)' },
  { value: 'theta', label: 'Theta (THETA)' },
  { value: 'tia', label: 'Tianhe (TIA)' },
  { value: 'time', label: 'Chrono.tech (TIME)' },
  { value: 'tjs', label: 'Tajikistani Somoni (TJS)' },
  { value: 'tmm', label: 'Turkmenistani Manat (TMM)' },
  { value: 'tmt', label: 'Turkmenistani Manat (TMT)' },
  { value: 'tnd', label: 'Tunisian Dinar (TND)' },
  { value: 'ton', label: 'Tokamak Network (TON)' },
  { value: 'tone', label: 'TE-FOOD (TONE)' },
  { value: 'top', label: "Tongan Pa'anga (TOP)" },
  { value: 'trac', label: 'OriginTrail (TRAC)' },
  { value: 'trb', label: 'Tellor (TRB)' },
  { value: 'tribe', label: 'Tribe (TRIBE)' },
  { value: 'trl', label: 'Turkish Lira (TRL)' },
  { value: 'tru', label: 'TrueFi (TRU)' },
  { value: 'trx', label: 'TRON (TRX)' },
  { value: 'try', label: 'Turkish Lira (TRY)' },
  { value: 'ttd', label: 'Trinidadian Dollar (TTD)' },
  { value: 'ttt', label: 'Tap Project (TTT)' },
  { value: 'tusd', label: 'True USD (TUSD)' },
  { value: 'tvd', label: 'Tuvaluan Dollar (TVD)' },
  { value: 'tvk', label: 'Terra Virtua Kolect (TVK)' },
  { value: 'twd', label: 'Taiwan New Dollar (TWD)' },
  { value: 'twt', label: 'Trust Wallet Token (TWT)' },
  { value: 'tzs', label: 'Tanzanian Shilling (TZS)' },
  { value: 'ugx', label: 'Ugandan Shilling (UGX)' },
  { value: 'uma', label: 'Universal Market Access (UMA)' },
  { value: 'unfi', label: 'Unifi Protocol DAO (UNFI)' },
  { value: 'uni', label: 'Uniswap (UNI)' },
  { value: 'upi', label: 'Pawtocol (UPI)' },
  { value: 'usdc', label: 'USDC (USDC)' },
  { value: 'usdd', label: ' (USDD)' },
  { value: 'usdp', label: 'USDP Stablecoin (USDP)' },
  { value: 'ust', label: 'TerraUSD (UST)' },
  { value: 'uyu', label: 'Uruguayan Peso (UYU)' },
  { value: 'uzs', label: 'Uzbekistani Som (UZS)' },
  { value: 'val', label: 'Vatican City Lira (VAL)' },
  { value: 'vara', label: ' (VARA)' },
  { value: 'veb', label: 'Venezuelan Bolívar (VEB)' },
  { value: 'ved', label: ' (VED)' },
  { value: 'vef', label: 'Venezuelan Bolívar (VEF)' },
  { value: 'ves', label: 'Venezuelan Bolívar (VES)' },
  { value: 'vet', label: 'Vechain (VET)' },
  { value: 'vgx', label: 'Voyager Token (VGX)' },
  { value: 'vnd', label: 'Vietnamese Dong (VND)' },
  { value: 'voxel', label: 'Voxies (VOXEL)' },
  { value: 'vtho', label: 'VeChainThor (VTHO)' },
  { value: 'vuv', label: 'Ni-Vanuatu Vatu (VUV)' },
  { value: 'wampl', label: 'Wrapped Ampleforth (WAMPL)' },
  { value: 'waves', label: 'Waves (WAVES)' },
  { value: 'waxl', label: 'Axelar (WAXL)' },
  { value: 'wbtc', label: 'Wrapped Bitcoin (WBTC)' },
  { value: 'wcfg', label: 'Wrapped Centrifuge (WCFG)' },
  { value: 'wemix', label: 'WEMIX (WEMIX)' },
  { value: 'wluna', label: 'Wrapped LUNA (WLUNA)' },
  { value: 'woo', label: 'WOO Network (WOO)' },
  { value: 'wst', label: 'Samoan Tala (WST)' },
  { value: 'xaf', label: 'Central African CFA Franc BEAC (XAF)' },
  { value: 'xag', label: 'Silver Ounce (XAG)' },
  { value: 'xau', label: 'Gold Ounce (XAU)' },
  { value: 'xaut', label: 'Tether Gold (XAUT)' },
  { value: 'xbt', label: ' (XBT)' },
  { value: 'xcd', label: 'East Caribbean Dollar (XCD)' },
  { value: 'xch', label: 'Chia (XCH)' },
  { value: 'xcn', label: 'Chain (XCN)' },
  { value: 'xdc', label: 'XDC Network (XDC)' },
  { value: 'xdr', label: 'IMF Special Drawing Rights (XDR)' },
  { value: 'xec', label: 'Eternal Coin (XEC)' },
  { value: 'xem', label: 'NEM (XEM)' },
  { value: 'xlm', label: 'Stellar Lumen (XLM)' },
  { value: 'xmon', label: 'XMON (XMON)' },
  { value: 'xmr', label: 'Monero (XMR)' },
  { value: 'xof', label: 'CFA Franc (XOF)' },
  { value: 'xpd', label: 'Palladium Ounce (XPD)' },
  { value: 'xpf', label: 'CFP Franc (XPF)' },
  { value: 'xpt', label: 'Platinum Ounce (XPT)' },
  { value: 'xrp', label: 'Ripple (XRP)' },
  { value: 'xtz', label: 'Tezos (XTZ)' },
  { value: 'xyo', label: 'XYO Network (XYO)' },
  { value: 'yer', label: 'Yemeni Rial (YER)' },
  { value: 'yfi', label: 'Yearn Finance (YFI)' },
  { value: 'yfii', label: 'DFI.Money (YFII)' },
  { value: 'zar', label: 'South African Rand (ZAR)' },
  { value: 'zec', label: 'ZCash (ZEC)' },
  { value: 'zen', label: 'Horizen (ZEN)' },
  { value: 'zil', label: 'Zilliqa (ZIL)' },
  { value: 'zmk', label: 'Zambian Kwacha (ZMK)' },
  { value: 'zmw', label: 'Zambian Kwacha (ZMW)' },
  { value: 'zrx', label: 'ZRX 0x (ZRX)' },
  { value: 'zwd', label: 'Zimbabwean Dollar (ZWD)' },
  { value: 'zwl', label: 'Zimbabwean Dollar (ZWL)' },
];

export const currenciesLabelsList = currenciesList.map(({ label }) => label);
